import {Button, Input} from "antd";
import {EyeOutlined, EyeInvisibleOutlined, SearchOutlined} from "@ant-design/icons";

import styles from "./live-search.module.scss";

const LiveSearch = ({value, toogleStatsVisible, onChange, statsVisible, placeholder = "Name, E-mail, Phone"}) => {
    return (
        <>
            <Input value={value} onChange={onChange} className={`${styles.field} ${styles.searchField}`} placeholder={placeholder}
                   suffix={<SearchOutlined className={styles.searchIcon}/>}/>
            <Button onClick={toogleStatsVisible} className={`${styles.field} ${styles.visibleBtn}`} icon={statsVisible ? <EyeOutlined/> : <EyeInvisibleOutlined />} size="medium"/>
        </>
    )
}

export default LiveSearch;
